<div [ngSwitch]="this.status" id="errorContainer">

  <div *ngSwitchCase="403">
    <ngb-alert type="info" [dismissible]="false">
      <i class="fa fa-info-circle"></i>
      <span [innerHtml]=" 'COMMON.ERROR_INSUFFICIENT_PRIVILEGES' | translate "></span>
    </ngb-alert>
  </div>

  <div *ngSwitchCase="401">
    <ngb-alert type="info" [dismissible]="false">
      <i class="fa fa-info-circle"></i>
      <span [innerHtml]=" 'COMMON.ERROR_UNAUTHORIZED' | translate "></span>
    </ngb-alert>
  </div>

  <div *ngSwitchCase="400">
    <ngb-alert type="danger" [dismissible]="false">
      <i class="fa fa-times-circle"></i>
      <span [innerHtml]=" 'COMMON.ERROR_INVALID_PAYLOAD' | translate "></span>
    </ngb-alert>
  </div>

  <div *ngSwitchCase="500">
    <ngb-alert type="danger" [dismissible]="false">
      <div>
        <i class="fa fa-times-circle"></i>
        <span [innerHtml]=" 'COMMON.ERROR_UNKNOWN' | translate "></span>
      </div>
      <div *ngIf="!production">
        <div class="flex-row">
          <div class="flex-20">error:</div>
          <div class="flex-80"><strong>{{ error }}</strong></div>
        </div>
        <div class="flex-row">
          <div class="flex-20">error description:</div>
          <div class="flex-80"><strong>{{ errorDescription }}</strong></div>
        </div>
      </div>
    </ngb-alert>
  </div>


  <div *ngSwitchDefault>
    <ngb-alert type="info" [dismissible]="false">
      <i class="fa fa-info-circle"></i>
      <span [innerHtml]=" 'COMMON.ERROR_UNKNOWN' | translate "></span>
    </ngb-alert>
  </div>
</div>
